import { render, staticRenderFns } from "./BookerPhone.vue?vue&type=template&id=af969a4a&scoped=true"
import script from "./BookerPhone.vue?vue&type=script&lang=js"
export * from "./BookerPhone.vue?vue&type=script&lang=js"
import style0 from "./BookerPhone.vue?vue&type=style&index=0&id=af969a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af969a4a",
  null
  
)

export default component.exports